import { siteInfo } from '@/mocks/home';

export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] lg:min-h-[640px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-950"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50 z-10"></div>

      <div className="relative z-20 w-full px-4 md:px-6 py-20 lg:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-5 whitespace-nowrap">
              全网最全黑料吃瓜平台
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-4">
              {siteInfo.name} - {siteInfo.corePositioning}
            </h1>
            <p className="text-lg md:text-xl text-background-50/80 font-heading mb-6">
              {siteInfo.slogan}
            </p>
            <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-4 max-w-xl lg:max-w-none">
              {siteInfo.description1}
            </p>
            <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-8 max-w-xl lg:max-w-none">
              {siteInfo.description2}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-50/60 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#topics')}
                className="px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                立即吃瓜
              </button>
              <button
                onClick={() => handleScroll('#ranking')}
                className="px-8 py-3 rounded-full border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                查看热榜
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] lg:aspect-auto lg:h-[420px] rounded-2xl overflow-hidden">
              <img
                src={siteInfo.heroImage}
                alt="17黑料网 - 网红黑料吃瓜平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}